<template>
  <div class="box box-info">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <form>
      <div class="p-grid justify-content-end">
          <div class="p-col">
            <Button class="p-button p-component p-button-success addNewBtn btn-btm-0"  @click.prevent="openBasic" icon="pi pi-plus" label="NEW" />
          </div>
        </div>
      <Dialog header="Leave Period" :visible.sync="displayBasic" @show="checkNepaliDateOrEnglish"
              :style="{width: '40vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-2">
            <label for="fiscalYear">Fiscal year</label>
            <div class="p-field p-col-12 p-md-2">
              <span id="fiscalYear">{{ $store.getters.fyName }}</span>
            </div>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label for="startDate">Start Date</label>
            <date-picker v-model="startDate" valueType="format" v-if="!englishDateEnabled"/>
            <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="startDate"
                       v-model="startDate"/>
          </div>
          <div class="p-field p-col-12 p-md-4">
            <label for="endDate">End Date</label>
            <date-picker v-model="endDate" valueType="format" v-if="!englishDateEnabled"/>
            <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="endDate"
                       v-model="endDate"/>
          </div>

        </div>
        <template #footer>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-6">
              <Button class="p-button-raised" @click.prevent="addLeavePeriod"
                      :label="!editing?'Add':'Update'"/>
              <Button class="p-button-raised p-button-info" v-if="!editing"
                      label="Add & New"/>
              <Button class="p-button-raised p-button-danger" @click.prevent="cancel" label="Cancel"/>
            </div>
          </div>
        </template>
      </Dialog>
    </form>
    <DataTable :value="leavePeriodList" :paginator="true" :rows="8" :filters="filters"
               class="p-datatable-responsive-demo p-datatable-gridlines">
      <Column header="S.N">
        <template #body="sl">
          {{sl.index+1}}
        </template>
      </Column>
      <Column header="Name" :sortable="true" field="name" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['name']"/>
        </template>
      </Column>
       <Column header="From Date" :sortable="true" field="startDate" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['startDate']"/>
        </template>
      </Column>
       <Column header="To Date" :sortable="true" field="endDate" filterMatchMode="contains">
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['endDate']"/>
        </template>
      </Column>
      <template #empty>No record found</template>
      <Column header="Action">
        <template #body="slotProps">
          <!-- Edit Button -->
          <Button icon="pi pi-pencil" class="p-button-raised p-button-success"
                  @click="editLeavePeriod(slotProps.data)"/>
          <!--        <Button icon="pi pi-pencil" v-else disabled class="p-button-raised p-button-success"-->
          <!--                @click="editSalesOrder(slotProps.data)"/>-->
          <!-- Edit button -->
          <!-- DeleteButton -->
          <Button class="p-button-raised p-button-danger"
                  @click="openDeleteDialog(slotProps.data.id)" icon="pi pi-trash"/>
          <!--        <Button v-else disabled class="p-button-raised p-button-danger"-->
          <!--                @click="openDialog(slotProps.data.id)" icon="pi pi-trash"/>-->
          <!-- Delete Button -->
        </template>
      </Column>
    </DataTable>
    <DeleteDialog v-model="deleteDialog" @cancel="cancelDelete" @deleted="deleteLeavePeriod"/>
  </div>
</template>
<script>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import DataTable from 'primevue/datatable'
import DeleteDialog from '../../../layout/dialog'
import Column from 'primevue/column'
import InputMask from 'primevue/inputmask'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'

export default {
  name: 'leavePeriod',
  data() {
    return {
      displayBasic: false,
      holidayType: null,
      loading: false,
      editing: false,
      leavePeriodId: null,
      deleteDialog: false,
      startDate: null,
      endDate: null,
      startDateNepali: null,
      endDateNepali: null,
      englishDateEnabled: true,
      filters: {}
    }
  },
  computed: {
    leavePeriodList() {
      return this.$store.state.hr.leavePeriodList
    }
  },
  mounted() {
    this.findLeavePeriodList()
  },
  methods: {
    async findLeavePeriodList() {
      await this.$store.dispatch('loadLeavePeriodList')
    },
    async addLeavePeriod() {
      let leavePeriod = {
        id: this.leavePeriodId,
        name: this.$store.getters.fyName,
        startDate: this.startDate,
        endDate: this.endDate,
        startDateNepali: this.startDate,
        endDateNepali: this.endDate
      }
      let response = ''
      try {
        if (!this.editing) {
          this.loading = true
          response = await this.$store.dispatch('createLeavePeriod', leavePeriod)
          this.loading = false
        } else {
          this.loading = true
          response = await this.$store.dispatch('updateLeavePeriod', leavePeriod)
          this.loading = false
        }
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: response.data.message, life: 3000})
        }
      } catch (e) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Something went wrong!!', life: 3000})
        this.loading = false
        return
      }
      this.reset()
    },
    editLeavePeriod(data) {
      this.editing = true
      this.leavePeriodId = data.id
      this.name = data.name
      this.startDate = data.startDate
      this.endDate = data.endDate
      this.openBasic()
    },
    async deleteLeavePeriod(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete Reason cannot be empty!!', life: 3000})
        this.deleteDialog = true
        return
      }
      let leavePeriod = {
        id: this.leavePeriodId,
        deleteReason: value
      }
      try {
        let response = await this.$store.dispatch('deleteLeavePeriod', leavePeriod)
        if (response.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: 'Leave Period' + response.data.message, life: 3000})
          this.deleteDialog = false
        }
      } catch (e) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'Something went wrong!!', life: 3000})
        return
      }
    },
    reset() {
      this.displayBasic = false
    },
    openDeleteDialog(id) {
      this.leavePeriodId = id
      this.deleteDialog = true
    },
    openBasic() {
      this.displayBasic = true
    },
    closeBasic() {
      this.displayBasic = false
    },
    cancelDelete(data) {
      this.deleteDialog = false
    },
    cancel() {
      this.displayBasic = false
    },
    checkNepaliDateOrEnglish() {
      this.checkEnglish()
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.nepaliDate()
      }
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      }
      if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
        this.setEnglishDate()
      }
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.startDate = this.$store.getters.nepaliNewDate
        this.endDate = this.$store.getters.nepaliNewDate
      }
    },
    setEnglishDate() {
      this.startDate = new Date().toISOString().slice(0, 10)
      this.endDate = new Date().toISOString().slice(0, 10)
    },
    nepaliDate() {
      $('#startDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.startDate = $('#startDate').val()
        }
      })
      $('#endDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.endDate = $('#endDate').val()
        }
      })
    }
  },
  components: {
    Dialog,
    Button,
    InputText,
    DataTable,
    Column,
    DeleteDialog,
    InputMask,
    DatePicker
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
</style>



// WEBPACK FOOTER //
// leavePeriod.vue?20b437d8